import ROUTES from "../routesConstants";

const ROLES = [
    {
        name: 'APP_ADMIN',
        menu: [
            {
                name: 'Administración de la empresa',
                path: ROUTES.OLD_BUSINESS_REGISTER
            },
            {
                name: 'Administración de colaboradores',
                path: ROUTES.OLD_REGISTRO_EMPLEADOS
            },
            {
                name: 'Listado de pedidos en curso',
                path: ROUTES.OLD_GESTION_PEDIDOS
            },
            {
                name: 'Catálogo de productos',
                path: ROUTES.OLD_PRODUCTS
            },
        ],
        routes: [
            {
                name: 'Administración de la empresa',
                path: ROUTES.OLD_BUSINESS_REGISTER
              },
              {
                name: 'Administración de colaboradores',
                path: ROUTES.OLD_REGISTRO_EMPLEADOS
              },
              {
                name: 'Listado de pedidos en curso',
                path: ROUTES.OLD_GESTION_PEDIDOS
              },
              {
                name: 'Catálogo de productos',
                path: ROUTES.OLD_PRODUCTS
              },
              {
                name: 'Actualizar mis datos',
                path: ROUTES.UPDATE_USER
              },
              {
                name: 'Actualizar contraseña',
                path: ROUTES.UPDATE_PASSWORD
              },
        ]
    },
    {
        name: 'APP_TIENDA',
        menu: [
            {
              name: 'Catálogo de productos',
              path: ROUTES.OLD_PRODUCTS
            },
            {
                name: 'Listado de pedidos en curso',
                path: ROUTES.OLD_GESTION_PEDIDOS
            },
            {
                name: 'Catálogo de productos',
                path: ROUTES.OLD_PRODUCTS
            },
        ],
        routes: [
              {
                name: 'Catálogo de productos',
                path: ROUTES.OLD_PRODUCTS
              },  
              {
                name: 'Listado de pedidos en curso',
                path: ROUTES.OLD_GESTION_PEDIDOS
              },
              {
                name: 'Actualizar mis datos',
                path: ROUTES.UPDATE_USER
              },
              {
                name: 'Actualizar contraseña',
                path: ROUTES.UPDATE_PASSWORD
              },
            // ROOT = '/',
            // LOGIN = '/sign-in-business',
            // SIGNUP = '/sign-up-business',
        ]
    },

]

export default  ROLES;